import { action } from "satcheljs";

import type { UserEmailAddress } from "accelerator-aad/lib/UserEmailAddress";
import type { CollaboratorSource } from "../serviceTypes/CollaboratorSource";

/**
 * Action called when we have completed fetching the collaborators
 */
export interface CollaboratorsFetchedActionActionMessage {
    collaborators: UserEmailAddress[];
    category: CollaboratorSource;
}
export const collaboratorsFetchedAction: (collaborators: UserEmailAddress[], category: CollaboratorSource) => CollaboratorsFetchedActionActionMessage = action("collaboratorsFetchedAction", (collaborators: UserEmailAddress[], category: CollaboratorSource): CollaboratorsFetchedActionActionMessage => ({
    collaborators,
    category,
}));
